import { BASE_URL } from '../../../Constant';

export const API_GET_ALL_DOCUMENT_CATEGORY_PAGE: string = `${BASE_URL}/document/category`;
export const API_DELETE_DOCUMENT_CATEGORY_PAGE: string = `${BASE_URL}/document/category`;
export const API_CREATE_DOCUMENT_CATEGORY_PAGE: string = `${BASE_URL}/document/category`;
export const API_UPDATE_DOCUMENT_CATEGORY_PAGE: string = `${BASE_URL}/document/category`;

export const DOCUMENT_CATEGORY_PAGE_STATUS_ACTIVE: number = 1;
export const DOCUMENT_CATEGORY_PAGE_STATUS_INACTIVE: number = 2;
export const DOCUMENT_CATEGORY_PAGE_TEMPLATE_STATUS_DELETED: number = 10;
